import JSBI from 'jsbi'

export const FACTORY_ADDRESS = '0x150170a4A4fA8A34dfC407f68CDE789E4dFfC103'

export const INIT_CODE_HASH = '0xdba94e407c3f312e94bf26f381b24ddafdbf4a893f71c30222e2b14c7eeaba07'

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const FIVE = JSBI.BigInt(5)
export const _997 = JSBI.BigInt(997)
export const _1000 = JSBI.BigInt(1000)
